import Page from 'components/ui/Page'
import React from 'react'
import { useParams } from 'react-router-dom'
import ServiceView from './ServiceView'

const ServiceViewPage = () => {
    const { id } = useParams()
    return (
        <Page title="services">
            <ServiceView serviceId={id} />
        </Page>
    )
}

ServiceViewPage.propTypes = {}

export default ServiceViewPage
